<!--
 Component to show either an existing res or the one about to be saved.
 Visit from /reservation/$resNo to load existing reservation
 or get here via the 5-step process to build up a reservation object in $state.
-->
<template>
  <v-layout row>
    <v-flex xs12>
      <template v-if="loading">
        <v-progress-linear :indeterminate="true"></v-progress-linear>
      </template>
      <v-container v-if="reservation">

        <h3 class="text-center mb-4">Please print this page for your future reference.</h3>

        <v-list-item class="mb-4 ml-n4">
          <v-list-item-content>
            <v-list-item-subtitle>Congratulations on your</v-list-item-subtitle>
            <v-list-item-title><h2>Vehicle Rental</h2></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-row>

          <TripDetails></TripDetails>

          <EstimateSummary :createdRes="reservation.ReservationNumber" v-if="reservation.ReservationStatus === 'open'"></EstimateSummary>
        </v-row>

        <v-row>
          <v-col cols="12" lg="6" class="trip-details">
            <h3 class="mb-4">Personal Information</h3>
            <v-row>
              <v-col cols="6">Last Name</v-col>
              <v-col cols="6">{{ Renter.LastName }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="6">First Name</v-col>
              <v-col cols="6">{{ Renter.FirstName }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="6">Address</v-col>
              <v-col cols="6">{{ Renter.Address.Street }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="6">City</v-col>
              <v-col cols="6">{{ Renter.Address.City }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="6">State</v-col>
              <v-col cols="6">{{ Renter.Address.StateOrProvCode }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="6">Zip / Postal Code</v-col>
              <v-col cols="6">{{ Renter.Address.PostalCode }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="6">Phone</v-col>
              <v-col cols="6">{{ Renter.Address.CellTelephoneNumber }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="6">E-Mail</v-col>
              <v-col cols="6">{{ Renter.Address.Email }}</v-col>
            </v-row>
          </v-col>

          <v-col cols="12" lg="6" class="trip-details">
            <h3 class="mb-4">Deposit Information</h3>
            <v-row>
              <v-col cols="6">Credit Card #</v-col>
              <v-col cols="6">{{ CardNumber }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="6">Expiration Date</v-col>
              <v-col cols="6">{{ this.reservation.Deposit.Expiry }}</v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card-actions class="justify-end flex-wrap">
          <v-btn v-if="reservation.ReservationStatus === 'new'" color="primary" @click="saveRes()">Book Now</v-btn>
        </v-card-actions>

      </v-container>

      <v-card-text>
        <p v-if="!resIsCancelable">
          If for any reason you need to cancel your reservation, please call
          1-800-327-7799 and provide your confirmation number.
        </p>
      </v-card-text>
      <v-card-text>
        <h5>VEHICLE GENERATOR FEE:</h5>
        <p>If equipped, vehicle generator hours are charged at $3.50 per hour.</p>
        <h5>RESERVATION CANCELLATION FEES:</h5>
        <p>With 7 days or more notice - no fee. With less than 7 days notice - forfeiture of $300.00 reservation deposit. For special events (Burning Man, music festivals) with less than 45 days of notice - forfeiture of all deposits.  Cruise America and the customer reserve the right to cancel at any time.</p>
        <p>Cruise America rentals in U.S. dollars.  Cruise Canada rentals in Canadian Dollars.</p>
        <p>Both Cruise America and Cruise Canada do not guarantee a specific motorhome brand or floorplan and reserve the right to substitute similar or higher rated vehicles. All vehicles may be operated by properly licensed and authorized drivers, 21 years of age or over, who must be present at departure to sign Rental Agreement.  All charges are payable in advance by credit card.</p>
        <p>For the purpose of renting vehicles from you, I certify that the above information is true and complete to the best of my knowledge.  I authorize you to check my credit.  I authorize you to charge prepayments/deposits on my credit card.  This application is not accepted until approved by a representative of lessor.  All prepayments/deposits will be refunded if application is not approved.  This application does not constitute a contract between parties.  Reservation applicant must sign a Rental Agreement at departure.</p>

        <h2 class="mt-8">CONGRATULATIONS!</h2>
        <p>You have completed the first step to enjoying a Cruise America RV.  For your convenience we have provided a number of helpful RV rental resources:</p>

        <v-row>
          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="2" md="3" class="d-flex align-center">
                <svg id="Video" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" width="100" height="100">
                  <svg:style type="text/css">.cls-1 { fill: #3273AF; } </svg:style>
                  <path class="cls-1" d="M134.24,107.58H16.48A3.62,3.62,0,0,1,12.86,104V32.36a3.63,3.63,0,0,1,3.62-3.62H134.24a3.63,3.63,0,0,1,3.62,3.62V104A3.62,3.62,0,0,1,134.24,107.58ZM16.48,31.74a.62.62,0,0,0-.62.62V104a.62.62,0,0,0,.62.62H134.24a.62.62,0,0,0,.62-.62V32.36a.62.62,0,0,0-.62-.62Z" />
                  <path class="cls-1" d="M75.36,43a25.2,25.2,0,1,0,25.2,25.2A25.2,25.2,0,0,0,75.36,43ZM88.75,69.89,68.51,83.11a2.12,2.12,0,0,1-3.28-1.78V56.2a2.12,2.12,0,0,1,3.2-1.83L88.67,66.28A2.13,2.13,0,0,1,88.75,69.89Z" />
                  <path class="cls-1" d="M139.19,117.07H93.77a4.68,4.68,0,0,0-9,0H10.59v3H84.88a4.71,4.71,0,0,0,8.75,0h45.56Z" />
                </svg>
              </v-col>
              <v-col cols="9" class="d-flex align-center">
                <h3>
                  <a href="http://www.cruiseamerica.com/rent/renters_resources/renters_orientation.aspx">
                    RV Rental Orientation Video
                  </a>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-n4">
                <p>Watch our <a href="http://www.cruiseamerica.com/rent/renters_resources/renters_orientation.aspx">renter's orientation video</a> online. This helpful presentation will show you the "ins and outs" of your RV rental, even before you pick it up. Learn more about unique features, discover helpful benefits, and ride in comfort.</p>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="2" md="3" class="d-flex align-center">
                <svg id="Manual" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" width="100" height="100">
                 <svg:style type="text/css">.cls-1 { fill: #3273AF; } </svg:style>
                 <title>Manual</title>
                 <path class="cls-1" d="M74.71,119.57c-.95,0-1.51-.93-2-1.83-.34-.57-1.37-2.3-1.92-2.46H16.67a5.63,5.63,0,0,1-5.62-5.63V35.83a5.62,5.62,0,0,1,5.62-5.62H70.76a5.63,5.63,0,0,1,5.63,5.62v81.72c0,1.34-.66,1.81-1.22,2A1.88,1.88,0,0,1,74.71,119.57Zm1-2.61h0Zm-4.94-1.68h0ZM16.67,33.21a2.62,2.62,0,0,0-2.62,2.62v73.82a2.62,2.62,0,0,0,2.62,2.63h54.1a3.67,3.67,0,0,1,2.62,1.3V35.83a2.62,2.62,0,0,0-2.63-2.62Z" />
                 <path class="cls-1" d="M75.06,119.57a1.86,1.86,0,0,1-.45-.06c-.56-.15-1.22-.62-1.22-2V35.83A5.62,5.62,0,0,1,79,30.21h54.1a5.62,5.62,0,0,1,5.62,5.62v73.82a5.63,5.63,0,0,1-5.62,5.63H79c-.55.16-1.58,1.89-1.92,2.46C76.57,118.64,76,119.57,75.06,119.57Zm4-86.36a2.62,2.62,0,0,0-2.62,2.62v77.75a3.65,3.65,0,0,1,2.61-1.3h54.11a2.63,2.63,0,0,0,2.62-2.63V35.83a2.62,2.62,0,0,0-2.62-2.62Z" />
                 <path class="cls-1" d="M66.8,43.86H19.45a1.5,1.5,0,0,1,0-3H66.8a1.5,1.5,0,0,1,0,3Z" />
                 <path class="cls-1" d="M66.8,55.7H19.45a1.5,1.5,0,0,1,0-3H66.8a1.5,1.5,0,0,1,0,3Z" />
                 <path class="cls-1" d="M66.8,67.54H19.45a1.5,1.5,0,0,1,0-3H66.8a1.5,1.5,0,0,1,0,3Z" />
                 <path class="cls-1" d="M66.8,79.37H19.45a1.5,1.5,0,0,1,0-3H66.8a1.5,1.5,0,1,1,0,3Z" />
                 <path class="cls-1" d="M66.8,91.21H19.45a1.5,1.5,0,0,1,0-3H66.8a1.5,1.5,0,0,1,0,3Z" />
                 <path class="cls-1" d="M66.8,103.05H19.45a1.5,1.5,0,0,1,0-3H66.8a1.5,1.5,0,0,1,0,3Z" />
                 <path class="cls-1" d="M129.54,43.86H82.19a1.5,1.5,0,0,1,0-3h47.35a1.5,1.5,0,0,1,0,3Z" />
                 <path class="cls-1" d="M129.54,55.7H82.19a1.5,1.5,0,0,1,0-3h47.35a1.5,1.5,0,0,1,0,3Z" />
                 <path class="cls-1" d="M129.54,67.54H82.19a1.5,1.5,0,0,1,0-3h47.35a1.5,1.5,0,0,1,0,3Z" />
                 <path class="cls-1" d="M129.54,79.37H82.19a1.5,1.5,0,0,1,0-3h47.35a1.5,1.5,0,0,1,0,3Z" />
                 <path class="cls-1" d="M129.54,91.21H82.19a1.5,1.5,0,0,1,0-3h47.35a1.5,1.5,0,0,1,0,3Z" />
                 <path class="cls-1" d="M129.54,103.05H82.19a1.5,1.5,0,0,1,0-3h47.35a1.5,1.5,0,0,1,0,3Z" />
               </svg>
              </v-col>
              <v-col cols="9" class="d-flex align-center">
                <h3>
                  <a href="http://www.cruiseamerica.com/rent/renters_resources/renters_assistance_guide.aspx">
                    Renter's Assistance Guide
                  </a>
                </h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-n4">
                <p>Everyone who rents an RV from Cruise America is supplied with an informative assistance guide before leaving the local rental center.  Don't wait.  Download the <a href="http://www.cruiseamerica.com/rent/renters_resources/renters_assistance_guide.aspx">renter's assistance guide</a> now and find informative tips on RV safety, operation and troubleshooting.</p>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="4">
            <v-row>
              <v-col cols="2" md="3" class="d-flex align-center">
                <svg id="Rent_to_Buy" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150" width="100" height="100">
                 <svg:style type="text/css">.cls-1 { fill: #3273AF; } </svg:style>
                 <title>renttobuy</title>
                 <path class="cls-1" d="M129.75,92.47h0l-16.69-16.7h1A8.88,8.88,0,0,0,114,58H79.28c-1.52-1-2.09-3.49-2.69-6.17-.91-4-2-9-7.19-10.85a12.62,12.62,0,0,0-9.31.2c-1.33-5.13-3.55-13.24-4.2-13L30.1,18.58A3.94,3.94,0,0,0,25,20.94l-6.12,17A3.94,3.94,0,0,0,21.35,43L43.7,50.53a3.93,3.93,0,0,0,2.58,0l11.46-4a3.92,3.92,0,0,0,2.11-1.78,9.52,9.52,0,0,1,8.55-.86c3.59,1.26,4.4,4.87,5.26,8.68A21.87,21.87,0,0,0,75.41,58H68.09c-2-3.72-9.82-5.66-17.31-5.66S35.44,54.3,33.47,58H31.88a4.62,4.62,0,0,0-4.61,4.61L27.42,115a4.62,4.62,0,0,0,4.62,4.6H33.3a11.64,11.64,0,0,0,23.11,0H99.18a11.64,11.64,0,0,0,23.1,0h4.21a4.62,4.62,0,0,0,4.61-4.62V95.73A4.63,4.63,0,0,0,129.75,92.47ZM44.54,33.92a8.39,8.39,0,0,0-3.63-2.68c-1.17-.41-2.15-.25-2.49.72-.42,1.21.93,1.76,2.41,2.76C42.68,36,44,37.39,43.27,39.63s-2.75,3-5.06,2.47l-.88,2.52L35.42,44l.88-2.55a9.36,9.36,0,0,1-2.84-2l.86-2.49a8.59,8.59,0,0,0,3.73,2.76c1.25.44,2.28.25,2.65-.8.44-1.29-1-1.89-2.47-2.91-1.81-1.19-3.14-2.58-2.38-4.76.7-2,2.6-2.8,4.8-2.38l.89-2.56,1.92.67-.88,2.54a9.13,9.13,0,0,1,2.81,2Zm.31,89.53a5.33,5.33,0,1,1,5.33-5.33A5.33,5.33,0,0,1,44.85,123.45Zm66.12,0a5.33,5.33,0,1,1,5.33-5.33A5.33,5.33,0,0,1,111,123.45Zm17.13-8.52a1.62,1.62,0,0,1-1.61,1.62h-4.08c-.06-.36-.13-.7-.22-1s-.22-.77-.35-1.13c-.07-.19-.14-.38-.22-.56a12.4,12.4,0,0,0-.81-1.58c-.17-.28-.36-.56-.54-.81l-.18-.25-.33-.39-.1-.12-.19-.24-.46-.48h0a11.57,11.57,0,0,0-1.83-1.51l-.1,0a8.94,8.94,0,0,0-.84-.51,12.16,12.16,0,0,0-14.79,2.48q-.24.27-.48.57c-.18.22-.36.46-.52.69a14.14,14.14,0,0,0-1,1.66c-.09.19-.17.39-.26.58a.67.67,0,0,1-.06.15l0,.15-.66,2.41H57.16c-.06-.35-.13-.7-.22-1a10.79,10.79,0,0,0-.36-1.14,10.46,10.46,0,0,0-.46-1.09,12.22,12.22,0,0,0-10.95-6.89,12.07,12.07,0,0,0-3.65.59,11.58,11.58,0,0,0-5.29,3.35l-.2.22c-.24.27-.46.57-.68.87a11.29,11.29,0,0,0-1.14,1.86,10.46,10.46,0,0,0-.46,1.09,10.79,10.79,0,0,0-.36,1.14c-.09.35-.16.69-.22,1H32a1.62,1.62,0,0,1-1.62-1.61l-.15-40.67V62.63A1.61,1.61,0,0,1,31.88,61h2.65A1.51,1.51,0,0,0,36,59.73c.27-1.82,6-4.37,14.76-4.37s14.5,2.55,14.76,4.37A1.51,1.51,0,0,0,67,61h47a5.88,5.88,0,0,1,0,11.75h-4.6a1.5,1.5,0,0,0-1.06,2.56l19.26,19.25a1.65,1.65,0,0,1,.47,1.15Z" />
                 <path class="cls-1" d="M56.19,73.22H39.89a1.5,1.5,0,0,0-1.5,1.5v9.44a1.5,1.5,0,0,0,1.5,1.5h16.3a1.5,1.5,0,0,0,1.5-1.5V74.72A1.5,1.5,0,0,0,56.19,73.22Zm-1.5,9.44H41.39V76.22h13.3Z" />
                 <path class="cls-1" d="M101.41,74.2a1.51,1.51,0,0,0-1-.44l-6.32-.36a1.49,1.49,0,0,0-1.58,1.5v13a1.5,1.5,0,0,0,1.5,1.5H113a1.49,1.49,0,0,0,1.38-.93,1.48,1.48,0,0,0-.32-1.63ZM95.53,86.37V76.49l4.16.23,9.65,9.65Z" />
                 <path class="cls-1" d="M87.14,73.67H68.45a1.5,1.5,0,0,0-1.5,1.5V110a1.5,1.5,0,0,0,1.5,1.5H87.14a1.5,1.5,0,0,0,1.5-1.5V75.17A1.5,1.5,0,0,0,87.14,73.67Zm-1.5,34.84H70V76.67H85.64Z" />
               </svg>
              </v-col>
              <v-col cols="9" class="d-flex align-center">
                <h3>Rent to Buy</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-n4">
                <p>Apply up to two weeks time and mileage charges towards the purchase of a Cruise America Motorhome.</p>
              </v-col>
            </v-row>
          </v-col>

        </v-row>

      </v-card-text>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import moment from "moment";
import TripDetails from '../components/TripDetails.vue'
import EstimateSummary from '../components/EstimateSummary.vue'

export default {
  name: 'ReservationSummaryPage',
  components: {
    TripDetails,
    EstimateSummary,
  },
  computed: {
    ...mapState({
      loading:'loading',
      estimate: state => state.reservation.estimate,
      rates: state => state.rates.rates,
      reservation: state => state.reservation.reservation,
      vehicleDescriptions: state => state.config.vehicleDescriptions,
    }),
    Renter () {
      // Init an empty object to avoid errors
      if (this.reservation && this.reservation.Renter){
        return this.reservation.Renter
      }
      else {
        return {"FirstName":"", "LastName":""}
      }
    },
    resIsEditable (){
      // TODO: enable res edit for cruise in phase 4
      return false;
    },
    daysUntilPickup () {
      if (!this.reservation.Pickup) {
        return 0;
      }
      let pickupDate = moment(this.reservation.Pickup.DateTime.substr(0, 10));
      let today = moment();
      return Math.ceil(pickupDate.diff(today, 'days', true));
    },
    resIsCancelable (){
      if (this.reservation.ReservationStatus !== 'open'){
        return false;
      }
      if (this.daysUntilPickup > 7){
        return true;
      }
      return false;
    },

    distanceUnit () {
      if (this.pickupLocation.CountryCode === 'CA'){
        return 'kilometer';
      }
      return 'mile';
    },
    CardNumber (){
      // mask card number

      return this.reservation.Deposit.CardNumber.replace(/.(?=.{4})/g, "*")
    },
  },
  methods: {
    ...mapMutations({
      updateRateQuery: 'rates/updateRateQuery',
      updateReservation: 'reservation/updateReservation'
    }),
    ...mapActions({
      getReservation: 'reservation/getReservation',
      editReservation: 'reservation/editReservation',
    }),
    editRenter () {
      this.$router.push({path: '/checkout'})
    },
    updateRateQueryFromReservation () {
      // Update the rate query to match the res
      this.updateRateQuery({
        PackageCode: this.reservation.PackageCode,
        Pickup: this.reservation.Pickup,
        Return: this.reservation.Return,
        Source: this.reservation.Source
      });
    },
    editRate () {
      this.updateRateQueryFromReservation()
      // Refresh the rates
      this.$store.dispatch('rates/getRates')
      .then(() => {
        this.$router.push({path: '/rates'})
      })
    },
    editItinerary () {
      this.updateRateQueryFromReservation()
      this.$router.push({path: '/itinerary'})
    },
    editOptions () {
      // Got to update rates first before getting Options
      this.updateRateQueryFromReservation()
      this.$store.dispatch('rates/getRates')
      .then(() => {
        let ratesRequestId = this.rates.ratesRequestId
        let rateClass = this.reservation.RateClass
        this.$store.dispatch('options/getOptions', {ratesRequestId, rateClass})
        .then(() => {
          this.$router.push({path: '/options'})
        })
      })
    },
    saveRes () {
      this.editReservation(this.reservation)
      .then((response) => {
        this.$router.push({path: `/confirmation/${response.ReservationNumber}`})
      })
    },
    loadRes () {
      if (this.$route.params.resNo && this.$route.params.resNo !== this.reservation.ReservationNumber){
        this.getReservation(this.$route.params.resNo)
        .catch(() => {
          // Error is displayed by global error handler.
          // Just go back if we failed
          this.$router.push({path: '/'});
        })
      }
      // otherwise we got here from the internal res object
    }
  },
  data () {
    return {
      showVehicle: false
    }
  },
  created () {
    this.$store.dispatch("config/rentingLocations");
    this.loadRes();
  },
  watch: {
    // call the method again if the route changes
    '$route': 'loadRes'
  },
};
</script>
<style>
.total {
  font-weight: bold;
}
th {
  font-weight: normal;
  padding: 1em 0 0.25em 0;
  font-size: 0.875rem;
}
</style>